export default "__VITE_ASSET__C9uRed_T__"